import map from 'lodash/map'

const requiredFields = {
  name: {
    title: 'Organization name',
    rule: '',
  },
  address: {
    title: 'address',
    rule: '',
  },
  place: {
    title: 'Location',
    rule: '',
  },
  email: {
    title: 'Email',
    rule: '',
  },
  phone: {
    title: 'Phone',
    rule: '',
  },
  accept: {
    title: 'Accept',
    rule: '',
  }
}

const validator = value => {
  const errors = {}

  map(requiredFields, ({ title }, field) => {
    if (field === 'accept') {
      if (!value[field]) errors[field] = 'You must accept and agree to the terms in the agreement from FlySpaces.'
    } else if (!value[field]) {
      errors[field] = `${title} field is required`
    } else if (
      field === 'email' &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[field])
    ) {
      errors[field] = `Invalid email format`
    }
  })
  return errors
}

export default validator
